export default "/images/96335e2fe31d5b43e8fcdb2eaa2b37b4.jpg";